export const organization = {
  title: "Organización",
  description: "Ajustes que se tocan poco.",
  domains: {
    title: "Dominios de Google Workspace",
    description:
      "Solo pueden entrar cuentas de Google de estos dominios. Además del dominio, cada persona tiene que estar invitada.",
    readOnly: "Los dominios los cambia Punto. Escríbenos si necesitas otro.",
  },
  retention: {
    title: "Retención del registro",
    description: "Firmas y navegación. Lo caducado se borra cada noche.",
    label: "Días que se conserva",
    days_one: "{{count}} día",
    days_other: "{{count}} días",
    save: "Guardar",
    saved: "Retención guardada: {{days}} días",
    errors: {
      range: "Entre 30 y 3650 días.",
    },
  },
  admins: {
    title: "Administradores",
    description:
      "Gestionan certificados, políticas y personas. Para añadir uno, cambia el rol de una persona en Personas.",
    empty: "No hay administradores.",
    manage: "Ir a Personas",
  },
  support: {
    title: "Acceso de soporte de Punto",
    description:
      "El equipo de Punto solo entra si lo concedes aquí, con plazo. Nunca puede firmar, y todo lo que haga queda en Actividad › Administración.",
    none: "Sin acceso concedido.",
    grant: "Conceder acceso…",
    grantTitle: "Conceder acceso de soporte",
    duration: "Durante",
    durations: {
      "24h": "24 horas",
      "3d": "3 días",
      "7d": "7 días",
    },
    access: "Qué puede hacer",
    accessOptions: {
      read_only: "Solo ver",
      full: "Ver y cambiar ajustes (nunca firmar)",
    },
    email: "Persona de Punto (opcional)",
    emailPlaceholder: "Cualquiera del equipo de soporte",
    emailHint:
      "Déjalo vacío para que entre quien atienda tu caso; queda registrado quién entra.",
    team: "Equipo de soporte de Punto",
    reason: "Motivo",
    reasonPlaceholder: "Revisar por qué se bloquea la sede de la DGT",
    submit: "Conceder",
    granted: "Acceso concedido hasta {{when}}",
    active: "Activo hasta {{when}}",
    columns: {
      who: "Quién",
      access: "Acceso",
      reason: "Motivo",
      until: "Hasta",
      status: "Estado",
    },
    revoke: "Revocar",
    revokeTitle: "¿Revocar el acceso de {{email}}?",
    revokeDescription:
      "Sus sesiones de soporte se cierran al momento. Queda registrado en Actividad › Administración.",
    revokeConfirm: "Revocar ahora",
    revoked: "Acceso revocado",
    history: "Accesos anteriores",
    errors: {
      reason: "Explica para qué.",
      email: "Escribe un email válido.",
    },
  },
  catalog: {
    title: "Catálogo de sedes",
    summary: "Versión {{version}} · {{domains}} dominios en {{groups}} grupos",
    description:
      "Solo se pueden usar certificados en estas sedes. Lo mantiene Punto porque va ligado a la CA de cada Mac.",
    view: "Ver",
    panelTitle: "Catálogo de sedes · versión {{version}}",
    groupId: "En las reglas: {{id}}",
  },
  macApp: {
    title: "App de Mac",
    description: "Descarga y cómo instalarla para tu equipo.",
    download: "Descargar",
    noDownload: "Pide el instalador al equipo de Punto.",
    steps: {
      one: "Descarga Punto.Firma y arrástrala a Aplicaciones.",
      two: "Ábrela y entra con la cuenta de Google de la organización.",
      three:
        "Mientras está abierta, las sedes del catálogo usan los certificados permitidos.",
    },
  },
};
